<template>
	<main class="clearfix">
    <div v-if="loading">
      <b-alert show lg="12" md="12" sm="12" variant="light" class="text-center">
        <div class="loader"></div>
      </b-alert>
    </div>
    <div class="clearfix border muted-border p2 pb3 mb2 shadow" v-for="customer in customers" :key="customer.id">
      <div class="col-12 p2">
        <p class="h4 darkblue semi-bold line-height-3 gibson">
          {{customer.Navn}}
        </p>
        <p class="h6 mediumgrey gibson line-height-1 mt2 mb1">
          Status
        </p>
        <b-form-select id="statusSelect" v-model="customer.Status" :options="customer.dataStatus" @change="changeStatus($event,customer)" class=" muted-background darkblue h6 gibson border-none not-rounded mb3">
        </b-form-select>
        <div class="my1">
          <div class="flex justify-between items-center">
            <div class="my1">
              <p class="h6 mediumgrey gibson line-height-1 mb1">
                Telefon
              </p>
              <p class="h5 darkblue gibson semi-bold">
                {{customer.Telefon}}
              </p>
            </div>
            <div class="my1">
              <p class="h6 mediumgrey gibson line-height-1 mb1">
                Email
              </p>
              <p class="h5 darkblue gibson semi-bold">
                {{customer.Email}}
              </p>
            </div>
          </div>
          <div class="my1">
            <p class="h6 mediumgrey gibson line-height-1 mb1">
              Postnummer/By
            </p>
            <p class="h5 darkblue gibson semi-bold">
              {{ customer.ZipCode }} {{ customer.City }}
            </p>
          </div>
          <div class="mt3">
            <button class="col-12 not-rounded border-none gibson p2 primary-button h5" @click="showItemDetails(customer)">
              <span>Læs notat</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-modal centered lazy v-model="reviewShow" ref="reviewModal" class="p2 px3 pb4">
      <div slot="modal-header" class="p0"></div>
      <div class="px2">
        <p class="h5 semi-bold regular darkblue gibson line-height-3 mb2" style="font-weight:600;">Notat:</p>
        <p v-html="sampleCustomer.Note" class="h5 regular darkblue gibson line-height-3 my2"></p>
      </div>
      <div slot="modal-footer" class="px2 py3">
        <button type="reset" @click="hideModal" class="standard-button p2 col-12 gibson border-none not-rounded">
          <span>Luk</span>
        </button>
      </div>
    </b-modal>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
	</main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import StarRating from 'vue-star-rating'
export default {
  name: 'reviews',
  components: {
    StarRating,
    loading,
    Simplert
  },
  props: ['id'],
  data () {
    return {
      rating: 0,
      show: false,
      loading: true,
      isLoadingReview: false,
      label: 'Loading...',
      overlay: 1,
      customers: [],
      reviewShow: false,
      reviewslength: false,
      text: '',
      sampleCustomer: []
    }
  },
  created () {
    this.Reload()
  },
  methods: {
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      if (localStorage.getItem('haaid') === '0') {
        this.loading = false
        return
      }
      var data = {operation: 'customers', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.loading = false
            this.customers = res
            this.show = false
            if (this.customers.length === 0) {
              this.reviewslength = true
            }
          },
          response => {
            alert('error')
          }
        )
    },
    changeStatus (value, item) {
      this.isLoadingReview = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'customer_status', salesPerson: this.salesPerson, levid: this.haaId, status: value, cid: item.Id}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.isLoadingReview = false
            if (res.success) {
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    review_service (item) {
      this.isLoadingReview = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'customer_comment', salesPerson: this.salesPerson, levid: this.haaId, item: item.ReviewId, note: item.SupplierRatingComment}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.isLoadingReview = false
            if (res.success) {
              alert('Gennemført!')
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    showItemDetails (customer) {
      this.reviewShow = !this.reviewShow
      this.sampleCustomer = customer
    },
    hideModal () {
      this.$refs.reviewModal.hide()
    },
    setRating (rating) {
      this.sampleCustomer.rating = rating
    }
  }
}
</script>
<style>
.card-header {
  font-weight: 700;
  border-bottom:0;
  font-size:1rem;
}
.card-footer {
  font-size:10px;
  border-top: 0;
}
.textarea {
  background: #ecf0f1;
}
.fa-times {
  font-size: 18px;
}
.modal-header,
.modal-footer {
  border-top: 0;
  border-bottom: 0;
  background: none;
  padding-bottom: 0;
}
.vue-star-rating-rating-text {
  display: none;
}
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
.loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before,
.loader:after {
  position: absolute;
  content: '';
}
.loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
.loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// Customers.vue?2422b843